import { atom } from 'jotai';

const previewAtom = atom<boolean>(false);

export { previewAtom };
